module.exports = __webpack_public_path__ + "static/media/goldStar.bef0ed5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/RequestTable/goldStar.svg
// module id = 156
// module chunks = 0